/** Centered OAuth popup helper (extracted from IntegrationsPage). */
export function openOAuthPopup(url: string, title: string): Window | null {
    const width = 600, height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;
    return window.open(url, title, `width=${width},height=${height},left=${left},top=${top}`);
}

export function waitForPopupClose(popup: Window, intervalMs = 1000): Promise<void> {
    return new Promise(resolve => {
        const timer = window.setInterval(() => {
            if (popup.closed) {
                window.clearInterval(timer);
                resolve();
            }
        }, intervalMs);
    });
}
